import { Customer } from 'generated/graphql'

export const mapCustomerValues = (customers: Customer[] = []) => {
  return customers.map((c) => ({ value: c.id, label: c.name }))
}
